import { Controller } from 'stimulus'

export default class extends Controller {
  static values = { url: String }
  static targets = ['frame']

  close() {
    if (!this.element.contains(event.target)) {
      this.element.requestSubmit()
    }
  }

  edit() {
    if (event.target.closest('a')) { return }

    this.frameTarget.src = this.urlValue
  }
}
